import { render, staticRenderFns } from "./PlanningAddDetailsView.vue?vue&type=template&id=0889baee&scoped=true"
import script from "./PlanningAddDetailsView.vue?vue&type=script&lang=ts"
export * from "./PlanningAddDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./PlanningAddDetailsView.vue?vue&type=style&index=0&id=0889baee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889baee",
  null
  
)

export default component.exports